import { render, staticRenderFns } from "./SellersTips.vue?vue&type=template&id=1c88b260&scoped=true&"
import script from "./SellersTips.vue?vue&type=script&lang=ts&"
export * from "./SellersTips.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c88b260",
  null
  
)

export default component.exports